import Route from 'app/interface/redux/types/core/route'

const DefaultRoute: Route = {
  title: '',
  path: '',
  component: null,
}

export default DefaultRoute
